/** 服务器估价 → Excel 导出 payload */

function todayStamp() {
  const d = new Date()
  const p = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`
}

function safeSlug(raw, fallback = 'report') {
  const s = String(raw || '')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, '-')
    .slice(0, 40)
  return s || fallback
}

export function buildBomReport({ keyword = '', quote, inquiryId = null }) {
  if (!quote) return null
  const label = quote.template_name || keyword || '估价'
  const title = `服务器估价报告 · ${label}`
  const headers = ['类别', '名称', '单价', '币种']
  const rows = (quote.items || []).map((it) => [
    it.category || '—',
    it.name || '—',
    it.unit_price ?? '—',
    it.currency || quote.currency || '—'
  ])
  const stamp = todayStamp()
  const base = `服务器估价-${safeSlug(label)}-${stamp}`
  const meta = [
    `标题：${title}`,
    `生成时间：${new Date().toLocaleString('zh-CN')}`,
    keyword ? `需求：${keyword}` : '来源：模板选择',
    quote.template_name ? `模板：${quote.template_name}` : '',
    quote.understand ? `理解：${quote.understand}` : '',
    `合计：${quote.total ?? '—'} ${quote.currency || ''}`,
    quote.note ? `备注：${quote.note}` : '',
    inquiryId ? `询价单号：${inquiryId}` : ''
  ].filter(Boolean)
  return {
    title,
    downloadKind: 'xlsx',
    filename: `${base}.xlsx`,
    exportPayload: {
      title,
      filename: base,
      sheets: [
        {
          name: '估价明细',
          meta,
          headers,
          rows,
          note: '算力百科 · 仅供参考，定稿请人工复核'
        }
      ]
    }
  }
}

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
